import { render } from "./PhotoTab.vue?vue&type=template&id=5d8ee69b"
import script from "./PhotoTab.vue?vue&type=script&lang=js"
export * from "./PhotoTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__